/** Convert the datetime-local control's browser-local wall time to a UTC instant. */
export function pushScheduleInstant(value: string, now = Date.now()): string | null {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
    const instant = new Date(value);
    if (!Number.isFinite(instant.getTime()) || instant.getTime() <= now) return null;
    // Reject invalid calendar dates and nonexistent local times rather than silently normalizing them.
    const pad = (n: number) => String(n).padStart(2, '0');
    const local = `${String(instant.getFullYear()).padStart(4, '0')}-${pad(instant.getMonth() + 1)}-${pad(instant.getDate())}T${pad(instant.getHours())}:${pad(instant.getMinutes())}`;
    return local === value ? instant.toISOString() : null;
}
